// import React from "react";
// import "./NavBar.css";

// const NavBar = () => {
//   return (
//     <>
//  <nav className="navbar navbar-expand-md navbar-dark navBarContainer fixed-top" style={{ backgroundColor: "white" }}>
//         <div className="container">
//           <a className="navbar-brand" href="#home">
//             <img
//               src={`https://cdn.builder.io/api/v1/image/assets%2F7fa683a22a9c42d7a697097e1847f1c9%2F29271bd60206424f8936d70a338b0501`}
//               alt="Mrchams Logo"
//               style={{ filter: "brightness(1.2)" }}
//             />
//           </a>
//           <button
//             className="navbar-toggler"
//             type="button"
//             data-bs-toggle="collapse"
//             data-bs-target="#collapsibleNavbar"
//             aria-controls="collapsibleNavbar"
//             aria-expanded="false"
//             aria-label="Toggle navigation"
//           >
//             <span className="navbar-toggler-icon"></span>
//           </button>
//           <div className="collapse navbar-collapse" id="collapsibleNavbar">
//             <ul className="navbar-nav ms-auto mx-2 ">
//               <li className="nav-item me-3">
//                 <a className="nav-link text-center" href="#home">
//                   Home
//                 </a>
//               </li>
//               <li className="nav-item me-3">
//                 <a className="nav-link text-center" href="#about-us">
//                   About Us
//                 </a>
//               </li>
//               <li className="nav-item me-3">
//                 <a className="nav-link text-center" href="#our-projects">
//                   Our Projects
//                 </a>
//               </li>
//               <li className="nav-item me-3">
//                 <a className="nav-link text-center" href="#location-map">
//                   Location
//                 </a>
//               </li>
//               <li className="nav-item me-3">
//                 <a className="nav-link text-center" href="#contact-us">
//                   Contact Us
//                 </a>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </nav>
//     </>
//   );
// };

// export default NavBar;




import React, { useEffect, useState } from "react";
import "./NavBar.css";

// Array of sections with corresponding labels
const sections = [
  { id: "home", label: "Home" },
  { id: "about-us", label: "About Us" },
  { id: "our-projects", label: "Our Projects" },
    { id: "location-map", label: " Location" },
  { id: "contact-us", label: "Contact Us" },
];

const NavBar = () => {
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 200;

      for (let section of sections) {
        const element = document.getElementById(section.id);
        if (element && scrollPosition >= element.offsetTop) {
          setActiveSection(section.id);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
// useEffect(() => {
//   const handleScroll = () => {
//     let current = activeSection;
//     let minDistance = Number.POSITIVE_INFINITY;
//     for (let section of sections) {
//       const element = document.getElementById(section.id);
//       if (element) {
//         const rect = element.getBoundingClientRect();
//         const distance = Math.abs(rect.top - 100);
//           if (distance < minDistance) {
//             minDistance = distance;
//             current = section.id;
//           }
//       }
//     }
//     setActiveSection(current);
//   };

//   window.addEventListener("scroll", handleScroll);
//   handleScroll(); // Trigger on load
//   return () => window.removeEventListener("scroll", handleScroll);
// }, []);

  return (
    <nav className="navbar navbar-expand-md navbar-dark navBarContainer fixed-top" style={{ backgroundColor: "white" }}>
      <div className="container">
        <a className="navbar-brand" href="#home">
          <img src="https://cdn.builder.io/api/v1/image/assets%2F7fa683a22a9c42d7a697097e1847f1c9%2F29271bd60206424f8936d70a338b0501" alt="Mrchams Logo" style={{ height: "40px" }} />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapsibleNavbar"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="collapsibleNavbar">
          <ul className="navbar-nav ms-auto">
            {sections.map(({ id, label }) => (
              <li className="nav-item" key={id}>
                <a
                  href={`#${id}`}
                  className={`nav-link text-center ${activeSection === id ? "active" : ""}`}
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;

